import React from 'react';

interface OCSSupplierConfigurationProps {
    configuration: {
        BaseUrl?: string;
        Timeout?: number;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface OCSConfigurationComponent extends React.FC<OCSSupplierConfigurationProps> {
    configFields: string[];
}

const OCSConfiguration: OCSConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🌐</span>
                    Базовый URL
                </label>
                <div className="input-group-custom">
                    <input
                        type="url"
                        className="form-input-custom"
                        value={configuration.BaseUrl || ''}
                        onChange={(e) => onChange('BaseUrl', e.target.value)}
                        placeholder="https://api.ocs.example.com"
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">⏱️</span>
                    Таймаут (секунды)
                </label>
                <div className="input-group-custom">
                    <input
                        type="number"
                        className="form-input-custom"
                        value={configuration.Timeout || ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            onChange('Timeout', value ? parseInt(value) : '');
                        }}
                        min="1"
                        placeholder="30"
                        disabled={disabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
OCSConfiguration.configFields = ['BaseUrl', 'Timeout'];

export default OCSConfiguration;
